import './addressManager.scss'
import TownList from '../droplist/townlist.js'
import MessageBoxManager from '../messageBox/messageBoxManager.js'
import EventManager from '../eventManager.js'
import Loader from '../loader/loader.js'
import FormManager from '../forms/formManager.js'

export default class AddressManager extends EventManager {
  constructor (options) {
    super()

    this.settings = $.extend({}, {
    }, options)

    this.$addressesCaroussel = $('.address-caroussel')

    this.formManager = new FormManager()

    this.messageBoxManager = new MessageBoxManager(
      this.$addressesCaroussel.closest('.contenu').children('.stacked-rounded-list'),
      {
        method: 'insertAfter',
        extraClasses: 'message-box'
      }
    )

    this.initHandlers(this.$addressesCaroussel.find('tfoot'))

    // init new address handler
    this.$addressesCaroussel.find('tfoot td.add button.add, tbody td.add').click(this.new.bind(this))

    // init cancel handler
    this.$addressesCaroussel.find('tfoot td.add button.cancel').click(this.resetAdd.bind(this))

    // init save handler
    this.$addressesCaroussel.find('tfoot td.add button.save').click(this.add.bind(this))

    // init edition handlers
    this.initPartial(this.$addressesCaroussel.find('tbody td [data-id]').closest('td'))

    // Display a message if no address has been entered yet
    if (this.$addressesCaroussel.find('tbody td [data-id]').length === 0) {
      this.messageBoxManager.notify('Avant tout, vous devez renseigner une adresse de livraison ci-dessous !', { type: 'warning' })
    }

    // listen scroll events on content
    const ScrollHandler = require('../scroll/scroll.js').default
    this.scrollHandler = new ScrollHandler(
      this.$addressesCaroussel.closest('.content'), {
        scrollSteps: this.$addressesCaroussel.find('tr').first().children().length
      }
    )

    this.loader = new Loader(this.$addressesCaroussel.closest('.scroll-wrapper'))

    var originalWidth = 300

    $(() => {
      originalWidth = this.$addressesCaroussel.find('td').outerWidth()
      $(window).on('resize', event => {
        let width = this.$addressesCaroussel.closest('.content').innerWidth()

        if (width < 800) {
          this.$addressesCaroussel.find('> tbody > tr > td').innerWidth(width)
        } else if (width >= 800) {
          this.$addressesCaroussel.find('> tbody > tr > td').innerWidth('')
        }

        // auto scroll to selected one
        this.scrollHandler.goTo(this.$addressesCaroussel.find('td.selected').index())
      }).resize()
    })
  }

  initPartial ($partial) {
    $partial.find('[data-incomplete]').prepend('<p class="color-main_alt"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Cette adresse est incomplète</p>')
    $partial.find('h3 a').click(this.edit.bind(this))
    $partial.click(this.select.bind(this))
  }

  initHandlers ($container) {
    // init chooser handler
    $container.find('button.choose[data-id]').click(this.select.bind(this))

    // init cancel handler
    $container.find('button.cancel[data-id]').click(this.display.bind(this))

    // init save handler
    $container.find('button.save[data-id]').click(this.save.bind(this))
  }

  setClass (id, classNames) {
    var $container = null
    var classNameToSkip = null

    if (id == 'add') {
      $container = this.$addressesCaroussel
        .find('td.add')
      classNameToSkip = 'add'
    } else {
      $container = this.$addressesCaroussel
        .find('td *[data-id=' + id + ']')
        .closest('td')
      classNameToSkip = 'selected'
    }

    return $container
      .removeClass((index, classNames) => classNames.replace(classNameToSkip, ''))
      .addClass(classNames)
  }

  edit (event, options) {
    options = Object.assign({}, {
      preValidate: false
    }, options)
    var $container = $(event.delegateTarget).closest('[data-id]')
    var address_id = $container.attr('data-id')
    event.stopPropagation()

    $.post('core/ajax/ajax_panier.php', {
      action: 'adresse_livr_form',
      id_adresse: address_id
    }).done(form => {
      this.setClass(address_id, 'edit')
      let $form = $container.closest('td').html(form).find('form')
      if (options.preValidate) {
        this.validate($form, true)
      }
      $form.submit(event => {
        var $form = $(event.delegateTarget)

        if (this.validate($form)) {
          super.on('change')

          $.post('core/ajax/ajax_panier.php', $form.serialize()).done(data => {
            this.display($form.attr('data-id'), address_id => {
              if ($form.closest('td').is('.selected')) {
                this.get(super.on.bind(this, 'select'))
              } else {
                this.selectAddressId(address_id)
              }
            })
          }).fail(data => {
            this.messageBoxManager.notifyUnexpectedError()
          })
        }

        return false
      })

      let $cp = $form.find('input[name=cp]')
      let $ville = $form.find('input[name=ville]')
      $cp.change(() => $ville.val(''))

      let townSuggestions = new TownList($cp)
        .addListener('select', (widget, town) => {
          $ville.val(town)
        })
        .addListener('reset', () => {
          $ville.val('')
        })
    }).fail(data => {
      this.messageBoxManager.notifyUnexpectedError()
    })
  }

  display (obj, callback) {
    var address_id = typeof obj === 'object'
      ? $(obj.delegateTarget).attr('data-id')
      : obj
    var $container = this.$addressesCaroussel.find('> tbody >tr > td > form[data-id=' + address_id + ']').closest('td')

    $.post('core/ajax/ajax_panier.php', {
      action: 'adresse_livr_partial',
      id_adresse: address_id
    }).done(partial => {
      this.initPartial($container.html(partial))
      this.setClass(address_id, '')
      if (callback !== undefined) {
        callback(address_id)
      }
    }).fail(data => {
      this.messageBoxManager.notifyUnexpectedError()
    })
  }

  append (address_id, callback) {
    var $addressItemContainer = $('<td/>')

    this.$addressesCaroussel
      .find('> tbody > tr > td.add')
      .before($addressItemContainer)

    $.post('core/ajax/ajax_panier.php', {
      action: 'adresse_livr_partial',
      id_adresse: address_id
    }).done(partial => {
      this.initPartial($addressItemContainer.html(partial))
      var $buttonsContainer = $('<td/>')

      this.$addressesCaroussel
        .find('> tfoot > tr > td.add')
        .before($buttonsContainer)

      $.post('core/ajax/ajax_panier.php', {
        action: 'adresse_livr_handlers',
        id_adresse: address_id
      }).done(handlers => {
        this.initHandlers($buttonsContainer.html(handlers))
        if (callback !== undefined) {
          callback(address_id)
        }
      }).fail(data => {
        this.messageBoxManager.notifyUnexpectedError()
      })
    }).fail(data => {
      this.messageBoxManager.notifyUnexpectedError()
    })
  }

  resetAdd () {
    var $form = this.$addressesCaroussel
      .find('> tbody > tr > td.add > form')

    $form.remove()
    this.setClass('add', '')
  }

  new () {
    if (this.$addressesCaroussel.find('> tbody > tr > td.add').hasClass('edit')) {
      return
    }

    $.post('core/ajax/ajax_panier.php', {
      action: 'adresse_livr_form'
    }).done(form => {
      this.setClass('add', 'edit')
      let $form = $(form)
        .appendTo(this.$addressesCaroussel.find('> tbody > tr > td.add'))
        .submit(event => {
          var $form = $(event.delegateTarget)

          if (this.validate($form)) {
            $.post('core/ajax/ajax_panier.php', $form.serialize(), address_id => {
              this.resetAdd()
              this.append(address_id, this.selectAddressId.bind(this))
            })
          }

          return false
        })

      let $cp = $form.find('input[name=cp]')
      let $ville = $form.find('input[name=ville]')
      $cp.change(() => $ville.val(''))

      let townSuggestions = new TownList($cp)
        .addListener('select', (widget, town) => {
          $ville.val(town)
        })
        .addListener('reset', () => {
          $ville.val('')
        })
    }).fail(data => {
      this.messageBoxManager.notifyUnexpectedError()
    })
  }

  add () {
    var $form = this.$addressesCaroussel.find('> tbody > tr > td.add > form')
    $form.submit()
  }

  save (event) {
    var address_id = $(event.delegateTarget).attr('data-id')
    var $form = this.$addressesCaroussel.find('> tbody > tr > td > form[data-id=' + address_id + ']')
    $form.submit()
  }

  select (event) {
    let address_id = $(event.delegateTarget).attr('data-id')
      ? $(event.delegateTarget).attr('data-id')
      : $(event.delegateTarget).children('[data-id]').attr('data-id')

    if ($(event.delegateTarget).hasClass('edit') || $(event.delegateTarget).hasClass('selected')) {
      return
    }
    this.selectAddressId(address_id)
  }

  selectAddressId (address_id) {
    let tid = this.loader.startTask()

    super.on('change')
    $.post('core/ajax/ajax_panier.php', {
      action: 'adresse_livr',
      _format: 'json',
      id_adresse: address_id
    }).done(address => {
      this.$addressesCaroussel
        .find('td.selected')
        .toggleClass('selected', false)

      this.$addressesCaroussel
        .find('td *[data-id=' + address.id + ']')
        .closest('td')
        .toggleClass('selected', true)

      if (address.incomplete) {
        this.$addressesCaroussel.find('td *[data-id=' + address.id + '] h3 a').trigger('click', { preValidate: true })
      } else {
        super.on('select', address)
      }

      this.scrollHandler.goTo(this.$addressesCaroussel.find('td.selected').index())
    }).fail(data => {
      this.messageBoxManager.notifyUnexpectedError()
    }).always(() => this.loader.stopTask(tid))
  }

  get (callback) {
    $.post('core/ajax/ajax_panier.php', {
      action: 'adresse_livr',
      _format: 'json'
    }).done(address => {
      if (address.incomplete) {
        this.$addressesCaroussel.find('td *[data-id=' + address.id + '] h3 a').trigger('click', { preValidate: true })
      } else {
        callback(address)
      }
    }).fail(data => {
      this.messageBoxManager.notifyUnexpectedError()
    })
  }

  validate ($form, prevalidate = false) {
    var valid = true
    let errors = []

    $form.find('.needed:not([name=cp])').each((i, input) => {
      this.formManager.error.remove($(input))
      if ($(input).val() == '') {
        this.formManager.error.show($(input), "Merci d'indiquer votre  " + $(input).attr('rel').toLowerCase())
        valid = false
        errors.push("Merci d'indiquer votre  " + $(input).attr('rel').toLowerCase())
      }
    })

    this.formManager.error.remove($form.find('[name=tel]'))

    if ($form.find('[name=tel]').val() == '' && $form.find('[name=gsm]').val() == '') {
      this.formManager.error.show($form.find('[name=tel]'), "Merci d'indiquer au moins un numéro de téléphone")
      valid = false
      errors.push("Merci d'indiquer au moins un numéro de téléphone")
    }

    var pays = $form.find('[name=pays]').val()
    var cpStr = $form.find('[name=cp]').val()
    var cp = parseInt(cpStr)

    this.formManager.error.remove($form.find('[name=cp]'))

    if (['FRA', 'GLP', 'MTQ', 'GUF', 'REU', 'SPM', 'MYT', 'NCL', 'PYF', 'WLF'].indexOf(pays) != -1) {
      let cpRegExp = new RegExp('^[0-9]{5}$', 'g')
      let correction = false

      if (!cpRegExp.test(cpStr)) {
        this.formManager.error.show($form.find('[name=cp]'), 'Le code postal doit être composé de 5 chiffres. Merci de corriger.')
        valid = false
        errors.push("Le code postal doit être composé de 5 chiffres. Merci de corriger.")
      } else if (cp > 0 && cp < 96000) {
        if (pays != 'FRA') {
          $form.find('[name=pays]').find("option[value='FRA']").attr('selected', 'selected')
          correction = true
        }
      } else if (cp >= 97100 && cp <= 98699) {
        if (cp >= 97100 && cp <= 97199 && pays != 'GLP') {
          $form.find('[name=pays]').find("option[value='GLP']").attr('selected', 'selected')
          correction = true
        } else if (cp >= 97200 && cp <= 97299 && pays != 'MTQ') {
          $form.find('[name=pays]').find("option[value='MTQ']").attr('selected', 'selected')
          correction = true
        } else if (cp >= 97300 && cp <= 97399 && pays != 'GUF') {
          $form.find('[name=pays]').find("option[value='GUF']").attr('selected', 'selected')
          correction = true
        } else if (cp >= 97400 && cp <= 97499 && pays != 'REU') {
          $form.find('[name=pays]').find("option[value='REU']").attr('selected', 'selected')
          correction = true
        } else if (cp >= 97500 && cp <= 97599 && pays != 'SPM') {
          $form.find('[name=pays]').find("option[value='SPM']").attr('selected', 'selected')
          correction = true
        } else if (cp >= 97500 && cp <= 97599 && pays != 'MYT') {
          $form.find('[name=pays]').find("option[value='MYT']").attr('selected', 'selected')
          correction = true
        } else if (cp >= 98800 && cp <= 98899 && pays != 'NCL') {
          $form.find('[name=pays]').find("option[value='NCL']").attr('selected', 'selected')
          correction = true
        } else if (cp >= 98700 && cp <= 98799 && pays != 'PYF') {
          $form.find('[name=pays]').find("option[value='PYF']").attr('selected', 'selected')
          correction = true
        } else if (cp >= 98600 && cp <= 98699 && pays != 'WLF') {
          $form.find('[name=pays]').find("option[value='WLF']").prop('selected', 'selected')
          correction = true
        }
      }

      valid = valid && !correction

      if (correction) {
        this.formManager.error.show($form.find('[name=cp]'), 'Le pays indiqué ne correspond pas au code postal :  nous avons modifié le pays choisi.\nMerci de vérifier.')
        errors.push("Le pays indiqué ne correspond pas au code postal :  nous avons modifié le pays choisi.\nMerci de vérifier.")
      }

      if (!prevalidate) {
        let hasErrors = !valid && errors.length > 0;
        const shipping = document.querySelector('.contenu.adresses')
        let adressData = {
          form_name: 'form_adresse',
          form_status: hasErrors ? 'KO' : 'OK',
          form_errors: hasErrors ? errors : 'N/A'
        }
        shipping.setAttribute('data-address-send', JSON.stringify(adressData))
        window.dispatchEvent(new Event('formAddressSend'))
      }
    }

    return valid
  }

  parse (data) {
    var data = data.split('|')

    return {
      id: data[0],
      name: data[1],
      isDefault: data[2] > 0,
      civilite: data[3],
      company: data[4],
      lastname: data[5],
      firstname: data[6],
      street: data[7] + data[8] + data[9] + data[10] + data[11],
      cp: data[12],
      town: data[13],
      country: data[14],
      phone: data[15],
      gsm: data[16],
      fax: data[17],
      email: data[18],
      instruction: data[19],
      codePorte: data[20],
      countryFull: data[21]
    }
  }
}
